<template>
  <v-data-table :headers="headers" :items="allIrpfReports" :items-per-page="10000" class="elevation-1" hide-default-footer :sortable='false' v-if="allIrpfReports.length">
    <template v-slot:body="{ items }">
      <tbody>
        <tr v-for="item in items" :key="item.proposta">
          <td class="text-left">{{ item.ano}}</td>
          <td class="text-left">{{ item.nome}}</td>
          <td class="text-left">{{ item.operadora}}</td>
          <td class="text-left">
            <v-btn text icon small color="green" :href="`http://www.corporeadministradora.com.br/boletos/?tipo=irpf&cpf=${item.cpf}&proposta=${item.proposta}&codigo=${item.codigo}&acao=getInforme`" target="_blank"><v-icon>fal fa-cloud-download</v-icon></v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-data-table>
  <p v-else>{{irpfMessage}}.</p>
</template>
<script>
export default {
  data () {
    return {
      headers: [
        { text: "Ano Exercício", value: "ano" },
        { text: "Nome", value: "nome" },
        { text: "Operadora ", value: "operadora"},
        { text: "Download", value: ""}
      ],
    }
  },
  props: {
    irpfMessage: String,
    allIrpfReports: Array
  }
}
</script>
